import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-294442e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "assessment-category-detail tw-bg-[#ffffff] tw-p-[20px] tw-flex tw-flex-col tw-justify-between tw-items-start tw-gap-[13px] tw-flex-[1_0_0] tw-self-stretch tw-border tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)] tw-rounded-[6px] tw-border-solid tw-border-[#EFF0F1]" }
const _hoisted_2 = { class: "tw-w-full tw-flex tw-justify-between tw-font-Poppins tw-text-[15px] tw-font-[600] tw-text-[#211F58] tw-leading-[130%]" }
const _hoisted_3 = { class: "tw-flex tw-items-center tw-px-[5px] tw-py-[2px] tw-border-[1px] tw-border-solid tw-border-[#EFF0F1] tw-rounded-[4px]" }
const _hoisted_4 = { class: "tw-text-[11px] tw-font-[500] tw-text-[#878787] tw-leading-[130%] tw-truncate tw-max-w-[95px]" }
const _hoisted_5 = { class: "tw-flex tw-flex-col tw-gap-[6px] tw-w-full" }
const _hoisted_6 = { class: "tw-flex tw-justify-between tw-w-full" }
const _hoisted_7 = { class: "tw-text-[#211F58] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[130%] title" }
const _hoisted_8 = { class: "tw-text-[#B7B7B7] tw-text-[13px] tw-font-[400]" }
const _hoisted_9 = { class: "tw-text-[#878787] tw-font-[500]" }
const _hoisted_10 = { class: "tw-flex tw-justify-between tw-w-full" }
const _hoisted_11 = { class: "tw-text-[#211F58] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[130%] title" }
const _hoisted_12 = { class: "tw-text-[#211F58] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[130%] title" }
const _hoisted_13 = { class: "tw-text-[#B7B7B7] tw-text-[13px] tw-font-[400]" }
const _hoisted_14 = { class: "tw-text-[#878787] tw-font-[500]" }

import { ICategories } from "@/interfaces/assessments/ICategories";
import {
  computed,
  onMounted,
  onBeforeMount,
  onUnmounted,
  ComputedRef,
} from "vue";
import store from "@/store";
import { localStorageKey } from "@/utils/constants";
import { IChecklistMetricsCompletion } from "@/interfaces/assessments/IAssessmentDetails";
import { getComponentUiText } from "@/utils/utilities";


export default /*#__PURE__*/_defineComponent({
  __name: 'assessmentCategoryDetail',
  props: {
  title: { type: String, required: true, default: "" },
  checklistId: { type: Number, required: true },
  progressCategories: {
    type: Array as () => ICategories[],
    default: () => [],
  },
},
  emits: ["scrollToTop"],
  setup(__props, { emit }) {

const props = __props;



const activeCategory = computed(() => {
  const activeCategory = store.state.Assessment.activeCategory;
  const category = props.progressCategories.find(
    (c) => activeCategory === c.checklistItemCategoryId,
  );
  return category as ICategories;
});

const checklistMetricsCompletion: ComputedRef<IChecklistMetricsCompletion> =
  computed(() => store.getters["Assessment/getChecklistMetricsCompletion"]);

const checklistCompletion = computed(
  () => store.state.Assessment.overviewCardData?.completionCard,
);

const percentProgress = computed(() => {
  return parseFloat(
    (checklistMetricsCompletion.value.checklistCompletionPcnt * 100).toFixed(2),
  );
});



onBeforeMount(() => {
  const localActiveCategory = localStorage.getItem(
    localStorageKey.assessmentActiveCategory,
  );
  if (localActiveCategory) {
    store.dispatch("Assessment/changeActiveCategory", localActiveCategory);
  }
});

onMounted(() => {});

onUnmounted(() => {
  localStorage.removeItem(localStorageKey.assessmentActiveCategory);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(__props.title), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(activeCategory.value?.checklistItemCategoryLabel), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(getComponentUiText)("app-component-assessment-title-progress-1")), 1),
        _createElementVNode("div", _hoisted_8, [
          _createTextVNode(_toDisplayString(activeCategory.value?.checklistItemCategoryCompleted) + "/" + _toDisplayString(activeCategory.value?.checklistItemCategoryCount) + " ", 1),
          _createElementVNode("span", _hoisted_9, _toDisplayString((
                Number(activeCategory.value?.checklistItemCompletedPcnt) * 100
              ).toFixed(1)) + "% ", 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(getComponentUiText)(
              "app-component-assessments-question-type-2-icon-tooltip-score-1",
            )), 1),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createTextVNode(_toDisplayString(Math.round(+activeCategory.value?.checklistCategoryScore)) + "/" + _toDisplayString(Math.round(+activeCategory.value?.checklistCategoryScoreMax)) + " ", 1),
            _createElementVNode("span", _hoisted_14, _toDisplayString((activeCategory.value?.checklistCategoryScorePcnt * 100).toFixed(1)) + "%", 1)
          ])
        ])
      ])
    ])
  ]))
}
}

})